import EventEmitter2 from "eventemitter2";

const emitter = () => {
  try {
    window.taskEmitter = new EventEmitter2({
      wildcard: false,
      delimiter: ".",
      newListener: false,
      removeListener: false,
      verboseMemoryLeak: false,
      ignoreErrors: false,
    });
  } catch (e) {
    console.log(e);
  }
};

export {emitter};
